import type { Metadata } from "next";
import AdminPayments from "@/Component/Admin/AdminPayments";

export const metadata: Metadata = {
    title: "Payment | Connector Club",
    description: "",
};

const PaymentsPage = () => {
  return (
    <AdminPayments />
  )
}

export default PaymentsPage
